export default __webpack_public_path__ + "media/images/logo_imastodon-016a713f4e3181a9f8af3be82620faf5.svg";